import { render, staticRenderFns } from "./mes_box.vue?vue&type=template&id=fc52f172"
import script from "./mes_box.vue?vue&type=script&lang=js"
export * from "./mes_box.vue?vue&type=script&lang=js"
import style0 from "./mes_box.vue?vue&type=style&index=0&id=fc52f172&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VTextField})
